import { AllergyRowData } from "../tables/allergy";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { ResourceAnalysis } from "../components/resource-analysis";

export type AllergySidePanelContentProps = {
  data: AllergyRowData;
};

/**
 * Side panel content for allergy intolerance resources.
 * Shows allergy details, manifestation, and optionally AI analysis.
 */
export function AllergySidePanelContent({ data }: AllergySidePanelContentProps) {
  return (
    <SidePanelLayout
      title="Allergy Intolerance"
      subtitle={data.allergy}
      metadata={`First Seen: ${data.firstSeen}`}
    >
      <ResourceAnalysis />

      <DocumentsSection resources={[data.originalData]} resourceType="AllergyIntolerance" />
    </SidePanelLayout>
  );
}
